// ============================================================================
// rangeCacheRegras: chave, compatibilidade e reaproveitamento das buscas por
// período (fetchRange) — A2c e A4b do "Dashboard sem zero silencioso",
// 23/10/2026. Puro, sem React.
// ============================================================================
import { temFalhas } from './avecFalhas.js';

export const RANGE_CACHE_MAX = 8;                 // teto de chaves em memória (LRU)
export const RANGE_PASSADO_TTL_MS = 2 * 3600_000; // período passado completo: 2 h

const pad2 = (n) => String(n).padStart(2, '0');
export const isoLocal = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

export function normalizarUnidades(unidades) {
  if (!Array.isArray(unidades) || unidades.length === 0) return null;
  return [...new Set(unidades.filter(Boolean).map(String))].sort();
}

// A chave carrega a variante: quais unidades, se veio o 0031 paginado (x1) e
// se veio o leque do 0065 (p1). Antes a chave `${start}_${end}` ignorava o
// withExtras0031 e uma faixa sem o 0031 paginado podia servir quem precisava.
export function chaveRange(start, end, v = {}) {
  const u = normalizarUnidades(v.unidades);
  return `${start}_${end}|u=${u ? u.join(',') : '*'}|x${v.withExtras0031 ? 1 : 0}|p${v.semPacotesPorProf ? 0 : 1}`;
}

// Chaves que servem o pedido `v`: a exata primeiro, depois as que trazem MAIS
// (todas as unidades, com o 0031 paginado, com o 0065). Nunca uma com menos.
export function chavesCompativeis(start, end, v = {}) {
  const u = normalizarUnidades(v.unidades);
  const us = u ? [u, null] : [null];
  const xs = v.withExtras0031 ? [true] : [false, true];
  const ps = v.semPacotesPorProf ? [true, false] : [false];
  const out = [];
  for (const uu of us) for (const x of xs) for (const p of ps) {
    const k = chaveRange(start, end, { unidades: uu, withExtras0031: x, semPacotesPorProf: p });
    if (!out.includes(k)) out.push(k);
  }
  return out;
}

export function periodoPassado(endDate, hoje = new Date()) {
  return typeof endDate === 'string' && endDate < isoLocal(hoje);
}

// Período passado COMPLETO (sem falha) com menos de 2 h: reaproveita (até com
// force: passado completo não muda em 2 h; estorno tardio entra na próxima janela).
export function podeReusarPassado(entrada, agora = Date.now(), ttl = RANGE_PASSADO_TTL_MS) {
  return !!entrada && !!entrada.data && !temFalhas(entrada.data) && (agora - entrada.at) < ttl;
}

// Herança entre buscas do MESMO período: restrita a período passado (no
// período em aberto a falha mostra "Sem dado" e o Tentar de novo).
export function podeHerdar(antigo, endDate, hoje = new Date()) {
  return !!antigo && !!antigo.units && periodoPassado(endDate, hoje);
}

// LRU sobre Map: reinsere no fim e corta o mais velho.
export function lruDefinir(mapa, chave, valor, max = RANGE_CACHE_MAX) {
  mapa.delete(chave);
  mapa.set(chave, valor);
  while (mapa.size > max) {
    const velha = mapa.keys().next().value;
    if (velha === undefined) break;
    mapa.delete(velha);
  }
  return mapa;
}
